import { CryptoState } from "./CryptoContext";
import { getColors } from "./theme";

export default function getColorsHook() {
  const { theme } = CryptoState();
  return [getColors(theme)];
}
